document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.sofivra-header');
  if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    const mobileToggle = header.querySelector('.sofivra-header__mobile-toggle');
    const mobileNav = header.querySelector('.sofivra-header__mobile-nav');
    if (mobileToggle && mobileNav) {
      mobileToggle.addEventListener('click', () => {
        const isOpen = header.classList.toggle('is-mobile-open');
        mobileToggle.setAttribute('aria-expanded', String(isOpen));
        mobileToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      });
    }
  }

  document.querySelectorAll('[data-sofivra-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-sofivra-carousel-track]');
    const prev = carousel.querySelector('[data-sofivra-carousel-prev]');
    const next = carousel.querySelector('[data-sofivra-carousel-next]');
    if (!track || !prev || !next) return;

    const scrollAmount = () => Math.min(track.clientWidth * 0.85, 420);
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = prefersReducedMotion ? 'auto' : 'smooth';

    prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior }));
    next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior }));
  });

  document.querySelectorAll('[data-sofivra-faq]').forEach((faq) => {
    faq.querySelectorAll('details').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        faq.querySelectorAll('details[open]').forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  });

  const revealTargets = document.querySelectorAll(
    '.sofivra-section, .sofivra-commerce-page .sofivra-commerce-container > *, .sofivra-collection-card, .sofivra-product-benefits article'
  );
  if (revealTargets.length) {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealTargets.forEach((target) => target.classList.add('is-visible'));
    } else {
      revealTargets.forEach((target) => target.classList.add('sofivra-reveal'));
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
      );
      revealTargets.forEach((target) => observer.observe(target));
    }
  }

  const parallaxTargets = {
    hero: document.querySelector('.hero-section'),
    bgLayers: document.querySelectorAll('.parallax-bg')
  };
  let parallaxFrame = null;
  const setupParallax = () => {
    if (!parallaxTargets.hero && !parallaxTargets.bgLayers.length) return;
    const scrolled = window.pageYOffset;

    if (parallaxTargets.hero) {
      parallaxTargets.hero.style.transform = `translateY(${scrolled * 0.3}px)`;
    }

    parallaxTargets.bgLayers.forEach((layer, index) => {
      const speed = 0.5 + (index * 0.1);
      layer.style.transform = `translateY(${scrolled * speed}px)`;
    });
  };
  const requestParallax = () => {
    if (parallaxFrame) return;
    parallaxFrame = window.requestAnimationFrame(() => {
      setupParallax();
      parallaxFrame = null;
    });
  };

  setupParallax();
  window.addEventListener('scroll', requestParallax, { passive: true });

  setupProductGallery();
  setupVariantPreview();
  setupCartRealtimeTotals();
  initializeParticleSystem();
  setupProductCards();
  setupFilters();
  setupLoadMore();
});

function initializeParticleSystem() {
  const container = document.querySelector('.lace-particles');
  if (!container) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const particleCount = 18;

  for (let i = 0; i < particleCount; i++) {
    const particle = document.createElement('div');
    particle.className = 'lace-particle';

    const x = Math.random() * 100;
    const y = Math.random() * 100;
    const size = Math.random() * 20 + 10;

    particle.style.left = `${x}%`;
    particle.style.top = `${y}%`;
    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;
    particle.style.animationDelay = `${Math.random() * 15}s`;

    container.appendChild(particle);
  }

  const particles = container.querySelectorAll('.lace-particle');
  let mouseFrame = null;
  let mouseEvent = null;
  document.addEventListener('mousemove', (event) => {
    mouseEvent = event;
    if (mouseFrame) return;
    mouseFrame = window.requestAnimationFrame(() => {
      const event = mouseEvent;
      mouseFrame = null;
      if (!event) return;
    const mouseX = event.clientX / window.innerWidth;
    const mouseY = event.clientY / window.innerHeight;

      particles.forEach((particle, index) => {
      const offsetX = (mouseX - 0.5) * 30 * (index % 2 === 0 ? 1 : -1);
      const offsetY = (mouseY - 0.5) * 30 * (index % 2 === 0 ? 1 : -1);

      particle.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
    });
    });
  });
}

function setupProductGallery() {
  const gallery = document.querySelector('[data-sofivra-product-gallery]');
  if (!gallery) return;

  const primaryImage = gallery.querySelector('.sofivra-product-gallery__image');
  const thumbs = gallery.querySelectorAll('[data-sofivra-gallery-thumb]');
  if (!primaryImage || !thumbs.length) return;

  const setActiveThumb = (activeThumb) => {
    thumbs.forEach((thumb) => {
      const isActive = thumb === activeThumb;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-current', String(isActive));
    });
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const fullSrc = thumb.dataset.fullSrc;
      if (!fullSrc) return;
      primaryImage.src = fullSrc;
      if (thumb.dataset.fullSrcset) primaryImage.srcset = thumb.dataset.fullSrcset;
      setActiveThumb(thumb);
    });
  });
}

function setupVariantPreview() {
  const variantInputs = document.querySelectorAll('[data-sofivra-variant-input]');
  if (!variantInputs.length) return;

  const price = document.querySelector('[data-sofivra-current-price]');
  const priceWrap = document.querySelector('[data-sofivra-product-price]');

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      if (!input.checked) return;

      const matchingThumb = document.querySelector(`[data-sofivra-gallery-thumb][data-image-id="${input.dataset.variantImageId}"]`);
      if (matchingThumb) matchingThumb.click();
      if (price && input.dataset.variantPrice) price.textContent = input.dataset.variantPrice;
      if (priceWrap) {
        let compare = priceWrap.querySelector('[data-sofivra-compare-price]');
        if (input.dataset.variantComparePrice) {
          if (!compare) {
            compare = document.createElement('s');
            compare.dataset.sofivraComparePrice = '';
            priceWrap.appendChild(compare);
          }
          compare.textContent = input.dataset.variantComparePrice;
          compare.hidden = false;
        } else if (compare) {
          compare.hidden = true;
        }
      }
    });
  });
}

function setupCartRealtimeTotals() {
  const cartForm = document.querySelector('[data-sofivra-cart-form]');
  if (!cartForm) return;

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  };
  const subtotalNode = cartForm.querySelector('[data-sofivra-cart-subtotal]');
  const shippingPromo = cartForm.querySelector('[data-sofivra-shipping-promo]');
  const shippingMessage = cartForm.querySelector('[data-sofivra-shipping-message]');

  const updateTotals = () => {
    let subtotal = 0;
    cartForm.querySelectorAll('[data-sofivra-cart-item]').forEach((item) => {
      const input = item.querySelector('[data-sofivra-quantity-input]');
      const lineTotal = item.querySelector('[data-sofivra-line-total]');
      const quantity = Math.max(Number.parseInt(input?.value || '0', 10), 0);
      const unitPrice = Number.parseInt(item.dataset.linePrice || '0', 10);
      const total = quantity * unitPrice;
      subtotal += total;
      if (lineTotal) lineTotal.textContent = formatMoney(total);
    });
    if (subtotalNode) subtotalNode.textContent = formatMoney(subtotal);
    if (shippingPromo && shippingMessage) {
      const threshold = Number.parseInt(shippingPromo.dataset.freeShippingThreshold || '2000', 10);
      const remaining = Math.max(threshold - subtotal, 0);
      shippingPromo.classList.toggle('is-unlocked', remaining === 0);
      shippingMessage.textContent = remaining === 0
        ? 'Free shipping unlocked for this order.'
        : `Spend ${formatMoney(remaining)} more to unlock free shipping.`;
    }
  };

  cartForm.querySelectorAll('[data-sofivra-cart-item]').forEach((item) => {
    const input = item.querySelector('[data-sofivra-quantity-input]');
    const minus = item.querySelector('[data-sofivra-quantity-minus]');
    const plus = item.querySelector('[data-sofivra-quantity-plus]');
    if (!input) return;
    minus?.addEventListener('click', () => {
      input.value = Math.max(Number.parseInt(input.value || '0', 10) - 1, 0);
      updateTotals();
    });
    plus?.addEventListener('click', () => {
      input.value = Math.max(Number.parseInt(input.value || '0', 10) + 1, 1);
      updateTotals();
    });
    input.addEventListener('input', updateTotals);
  });

  updateTotals();
}

function setupProductCards() {
  const productCards = document.querySelectorAll('.product-card');

  productCards.forEach((card) => {
    card.addEventListener('mouseenter', () => {
      const preview = card.querySelector('.product-quick-preview');
      if (preview) {
        preview.style.opacity = '1';
      }
    });

    card.addEventListener('mouseleave', () => {
      const preview = card.querySelector('.product-quick-preview');
      if (preview) {
        preview.style.opacity = '0';
      }
    });
  });
}

function setupFilters() {
  const collectionFilter = document.getElementById('collection-filter');
  const colorFilter = document.getElementById('color-filter');
  const thicknessFilter = document.getElementById('thickness-filter');

  [collectionFilter, colorFilter, thicknessFilter].forEach((filter) => {
    if (filter) {
      filter.addEventListener('change', () => {
        applyFilters();
      });
    }
  });
}

function applyFilters() {
  const collectionFilter = document.getElementById('collection-filter');
  const colorFilter = document.getElementById('color-filter');
  const thicknessFilter = document.getElementById('thickness-filter');

  console.log('Applying filters', {
    collection: collectionFilter ? collectionFilter.value : '',
    color: colorFilter ? colorFilter.value : '',
    thickness: thicknessFilter ? thicknessFilter.value : ''
  });

  const productGrid = document.querySelector('.product-grid');
  if (productGrid) {
    productGrid.style.opacity = '0.5';

    setTimeout(() => {
      productGrid.style.opacity = '1';
    }, 500);
  }
}

function setupLoadMore() {
  const loadMoreBtn = document.querySelector('.load-more .btn');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      loadMoreBtn.textContent = 'Loading...';
      loadMoreBtn.disabled = true;

      setTimeout(() => {
        loadMoreBtn.textContent = 'Load more products';
        loadMoreBtn.disabled = false;

        console.log('Load more products');
      }, 2000);
    });
  }
}
